/*
Descrição..........: Módulo utilizado para roteamento
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020
*/

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CategoriaFormPage } from './categoria-form.page';

const routes: Routes = [
  {
    path: '',
    component: CategoriaFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CategoriaFormPageRoutingModule {}
